const GetSessionData = async (isAdmin = false) => {
    try {
        let sessionKeyName = process.env.REACT_APP_SESSION
        
        if (isAdmin) {
            sessionKeyName = process.env.REACT_APP_SESSION_ADM
        }

        const tmpUserData = sessionStorage.getItem(sessionKeyName)

        if (!tmpUserData) {
            return { success: false, message: null }
        }
        
        const userData = JSON.parse(tmpUserData)
        
        if (!userData) {
            return { success: false, message: null }
        }

        return { success: true, data: userData }
    } catch (error) {
        return { success: false, message: null }
    }
}

const UpdateSessionData = async (userData, isAdmin = false) => {
    try {
        let sessionKeyName = process.env.REACT_APP_SESSION
        
        if (isAdmin) {
            sessionKeyName = process.env.REACT_APP_SESSION_ADM
        }

        sessionStorage.setItem(sessionKeyName, JSON.stringify(userData))

        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: '' }
        //return { success: false, message: 'Hubo un error al intentar guardar la información. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeleteSessionData = async (isAdmin = false) => {
    try {
        let sessionKeyName = process.env.REACT_APP_SESSION
        
        if (isAdmin) {
            sessionKeyName = process.env.REACT_APP_SESSION_ADM
        }

        sessionStorage.removeItem(sessionKeyName)
        
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: '' }
        //return { success: false, message: 'Hubo un error al intentar guardar la información. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

export { GetSessionData, UpdateSessionData, DeleteSessionData };